import { FC } from 'react';

import { CompletedArea } from 'components/features/CompletedArea';
import { Paragraph } from 'components/parts/Paragraph';

import styles from '../Card.module.scss';
import { CardTabs } from 'components/pages/Card/sections/CardTabs';
import { CardsTabType } from 'components/pages/Card/model/types';

type Props = {
  numCompleted: number;
  numTotal: number;
  tab: CardsTabType;
  setTab: (tab: CardsTabType) => void;
};

export const TopSection: FC<Props> = ({ numCompleted, numTotal, tab, setTab }) => {
  const text =
    tab === 'area'
      ? 'エリアクリアごとにカードがもらえるよ！'
      : 'ミッションクリアでカードがもらえるよ！';
  const completedPlaceholder = tab === 'area' ? 'クリアしたエリア' : 'クリアしたミッション';
  return (
    <div className={styles.head}>
      <div className={styles.tabs}>
        <CardTabs tab={tab} setTab={setTab} />
      </div>
      <div className={styles.headInner}>
        <div className={styles.text1}>
          <Paragraph>{text}</Paragraph>
        </div>
        <div className={styles.completedArea}>
          <CompletedArea
            completedAreas={numCompleted}
            totalAreas={numTotal}
            placeholder={completedPlaceholder}
          />
        </div>
      </div>
    </div>
  );
};
